"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.meetsContrastWithBlockShades = exports.meetsContrast = void 0;
var chroma_js_1 = __importDefault(require("chroma-js"));
var NominalContrasts_1 = require("./NominalContrasts");
/**
 * Checks if the color combination of foreground and background meets the required contrast.
 */
function meetsContrast(foreground, background, minimumContrast) {
    if (minimumContrast === void 0) { minimumContrast = NominalContrasts_1.WCAGMinimumTextContrast; }
    if (!foreground || !background) {
        return false;
    }
    var contrast = chroma_js_1.default.contrast(foreground, background);
    return contrast >= minimumContrast;
}
exports.meetsContrast = meetsContrast;
/**
 * Checks if the color meets the required contrast against the base and container backgrounds.
 * When the base color is white or close to white, we skip the container check, since the logic
 * in buildThemes will set the background.base color used for alt-surfaces back to white.
 */
function meetsContrastWithBlockShades(color, blockShades, minimumContrast) {
    var base = blockShades.base, container = blockShades.container, isCloseToWhite = blockShades.isCloseToWhite, isWhite = blockShades.isWhite;
    var checkContainer = !isCloseToWhite && !isWhite;
    return (meetsContrast(color, base, minimumContrast) &&
        (checkContainer ? meetsContrast(color, container, minimumContrast) : true));
}
exports.meetsContrastWithBlockShades = meetsContrastWithBlockShades;
//# sourceMappingURL=meetsContrast.js.map